export const environment = {
  production: true,
  URL_API: 'https://api.demo.cayc.gesthispania.cloud/api',
  idleTimeInMinutes: 60,
  domain: 'front.demo.cayc.gesthispania.cloud'
};
